import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './slices/productsSlice';
import categoriesReducer from './slices/categoriesSlice';
import bannerReducer from './slices/bannerSlice';
import blogReducer from './slices/blogSlice';
import workshopsReducer from './slices/workshopsSlice';
import seoReducer from './slices/seoSlice';
import settingsReducer from './slices/settingsSlice';
import reviewsReducer from './slices/reviewsSlice';
import uiReducer from './slices/uiSlice';
import cartReducer from './slices/cartSlice';
import tenantReducer from './slices/tenantSlice';

export const store = configureStore({
  reducer: {
    products: productsReducer,
    categories: categoriesReducer,
    banner: bannerReducer,
    blog: blogReducer,
    workshops: workshopsReducer,
    seo: seoReducer,
    settings: settingsReducer,
    reviews: reviewsReducer,
    ui: uiReducer,
    cart: cartReducer,
    tenant: tenantReducer,
  },
});

